export default "__VITE_ASSET__xouWx2E___"